module.exports = {
  en: {
    MISSING_ANALYTICS_TITLE: 'Please install Google Analytics and share it with Adriel for better performance.',
    MISSING_ANALYTICS:
      "If you install Google Analytics on your website, Adriel can help you improve conversions. \n\nTo install, follow this <a href='https://support.google.com/analytics/answer/1008015'>link</a>.",
    MISSING_PIXEL_TITLE: 'Please install Pixel and share it with Adriel for better performance.',
    MISSING_PIXEL:
      "If you install Facebook Pixel on your website, Adriel can help you improve conversions. \n\nTo install, follow this <a href='https://www.facebook.com/business/m/pixel-setup-get-started'>link</a>.",
    OPTIMIZE_BUDGET_TITLE: 'Adriel optimized your campaigns by re-allocating the budget between platforms.',
    OPTIMIZE_BUDGET:
      "Adriel noticed that there's a better chance to maximize your campaign's performance and hence took following action(s).\n\nAdriel allocated more budget to a better performing platform(s). The total budget remains same.",
    DECREASE_BUDGET:
      'Adriel allocated more budget to a better performing platform(s) so that you achieve the adequate number of impressions. The total budget remains same.',
    SPEND_DROP_USER_TITLE: "Your {campaign} ad's number of impressions has dropped. See our suggestions.",
    SPEND_DROP_USER:
      'Adriel noticed that your {campaign} ad is spending much less than before. We recommend you taking following action(s) immediately.',
    SPEND_DROP_ADRIEL_TITLE: "Your {campaign} ad's number of impressions has dropped.",
    SPEND_DROP_ADRIEL: 'Adriel noticed that your {campaign} ad is spending much less than before.',
    UNDERSPENDING_USER_TITLE: '[Urgent] Your {campaign} ad has low impressions. Please make the necessary changes.',
    UNDERSPENDING_USER:
      'Adriel noticed that your {campaign} ad has low impression. We recommend you taking following action(s) immediately.',
    UNDERSPENDING_ADRIEL_TITLE: 'Your {campaign} ad has low impression.',
    UNDERSPENDING_ADRIEL:
      "Adriel noticed that your {campaign} ad has low impression. Adriel Team took actions in order to improve the performance.\n\nSee what's been improved:",
    // ADRIEL_ACTION: "\nTeam Adriel took actions in order to improve the performance.\n\nSee what's been improved:",
    // USER_ACTION: "\nWe recommend you taking following action(s) immediately.",
    // SEARCH_VOLUME_TOO_SMALL:"\nNo one searched for your keywords last month.\n | \nOnly one person searched for your keywords last month.\n | \nOnly {volume} persons search for your keywords each month.",
    ADD_MORE_KEYWORDS:
      'Current keywords have low search volume because few people search for the selected keywords. \n\nPlease add more keywords or reach out for help via online chat.',
    INCREASE_KEYWORD_BID:
      'Adriel increased the bids of some keywords so that your Google Search ad has a higher chance to be displayed.',
    SET_KEYWORDS_BROAD_MATCH:
      'Adriel used Broad Match for your keywords so that your Google Search ad has a higher chance to be displayed.',
    CONVERSION_BUDGET_TOO_SMALL:
      'The budget of your {campaign} ad is too low to effectively optimize for conversion due to high competition. \n\nWe recommend increasing the budget level to {min}.',
    INCREASE_AUDIENCE_SIZE:
      "{campaign} ad's target audience size is not large enough and therefore has little or no reach. \n\nAdriel Team will soon take actions to set better audience profile, e.g. tapping on more interests or age groups. \n\nIf you have comments, please reach out on our online chat.",
    LOW_RELEVANCY:
      "{campaign} ad's image and text are not preferred by the audience and therefore got penalized with limited reach. \n\nPlease try with a new image and text that are more appealing and relavant to your audience. You can reach out for help via online chat.",
    TOO_MUCH_TEXT_IN_IMAGE:
      "{campaign} ad's image contains too much text inside and therefore got penalized with limited reach. \n\nPlease try with a new image of less than 20 percent text coverage. \n\nRead more about the guideline <a href='https://www.facebook.com/business/help/980593475366490'>here.</a>\n\nCheck if your image will be penalized <a href='https://www.facebook.com/ads/tools/text_overlay'>here.</a>",
    INCREASE_CONVERSION_BID:
      'Adriel increased the bid cap so that your {campaign} ad has a higher chance to be displayed.',
    MORE_AGGRESSIVE_BID:
      'Adriel has taken a more aggressive bidding strategy so that your {campaign} ad has a higher chance to be displayed.',
    GO_TO_SETTINGS: 'Go to Ad Settings',
    cpc: 'cpc',
    ctr: 'ctr',
    spend: 'spend',
    google_search_campaign: 'Google search',
    google_display_campaign: 'Google display',
    google_universal_appstore: 'Google app sotre UAC',
    google_universal_playstore: 'Google play sotre UAC',
    google_campaign: 'Google',
    facebook_instagram_campaign: 'Facebook/Instagram',
    instagram_campaign: 'Instagram',
    facebook_campaign: 'Facebook',
    kakao_campaign: 'Kakao',
    apple_campaign: 'Apple',
    high: 'high {0}',
    low: 'low {0}',
  },
  ko: {
    MISSING_ANALYTICS_TITLE: '더 좋은 광고 성과를 위해 구글 애널리틱스를 설치 및 공유해주세요.',
    MISSING_ANALYTICS:
      "구글 애널리틱스 설치를 추천드립니다.\n\n구글 애널리틱스 설치시 리타겟팅, 유사 타겟팅, 전환 극대화 및 방문자의 행동 분석 등 다양한 최적화와 분석을 도와드릴 수 있습니다. \n\n<a href='https://support.google.com/analytics/answer/1008015?hl=en'>구글 에널리틱스 설치하기</a>",
    MISSING_PIXEL_TITLE: '더 좋은 광고 성과를 위해 페이스북 픽셀을 설치 및 공유해주세요.',
    MISSING_PIXEL:
      "페이스북 픽셀 설치 및 이벤트 설정을 추천드립니다. \n\n픽셀을 설치시 리타겟팅, 유사 타겟팅, 전환 극대화 등 방문자의 행동 분석 등 다양한 최적화와 분석을 도와드릴 수 있습니다. \n\n<a href='https://www.facebook.com/business/m/pixel-setup-get-started'>픽셀 설치하기</a>",
    OPTIMIZE_BUDGET_TITLE: '아드리엘이 {campaigns} 광고를 최적화하였습니다. ',
    OPTIMIZE_BUDGET:
      '더 효율적인 예산 소진을 위해 다음과 같이 최적화하였습니다.\n\n성과가 더 좋은 광고 채널에 예산을 집중하여 평균 클릭수와 클릭당 비용이 개선되도록 조정하였습니다. 총 예산은 변동되지 않습니다.',
    SPEND_DROP_USER_TITLE: '{campaign} 광고의 노출이 저하되어 조치가 필요합니다.',
    SPEND_DROP_USER:
      '광고주님의 {campaign} 광고의 노출이 급격히 저하되었습니다. 광고주님이 취해야할 조치를 안내드립니다.',
    SPEND_DROP_ADRIEL_TITLE: '{campaign} 광고의 노출이 저하되어 아드리엘이 조치를 취하였습니다.',
    SPEND_DROP_ADRIEL:
      '광고주님의 {campaign} 광고의 노출이 급격히 저하되어, 아드리엘 팀이 다음과 같은 조치를 취하였습니다.',
    UNDERSPENDING_USER_TITLE: '{campaign} 광고 예산 소진을 위해 조치가 필요합니다.',
    UNDERSPENDING_USER:
      '광고주님의 {campaign} 광고의 예산이 소진되고 있지 않습니다. 광고주님이 취해야할 조치를 안내드립니다.',
    UNDERSPENDING_ADRIEL_TITLE: '{campaign} 광고의 예산 소진을 위해 아드리엘이 조치를 취하였습니다.',
    UNDERSPENDING_ADRIEL:
      '광고주님의 {campaign} 광고가 제대로 노출되고 있지 않아, 아드리엘 팀이 아래와 같은 조치를 취하였습니다.',
    ADRIEL_ACTION: '아드리엘이 취한 조치를 공유드립니다.',
    USER_ACTION: '성과 개선을 위해 반드시 다음 조치를 취해 주시기 바랍니다.',
    DECREASE_BUDGET:
      '노출이 잘 되는 광고 채널에 더 많은 예산을 배분하여 평균 노출량이 향상되도록 조정하였습니다. 총 예산은 변동되지 않습니다.',
    ADD_MORE_KEYWORDS:
      '선택하신 검색 광고 키워드의 검색량이 저조합니다. 검색어를 추가하거나, 온라인 채팅창으로 부탁주세요.',
    INCREASE_KEYWORD_BID: '구글 검색 광고 노출을 개선하기 위해 검색어의 입찰가를 증액하였습니다.',
    SET_KEYWORDS_BROAD_MATCH:
      "구글 검색 광고 노출을 개선하기 위해 '확장검색 전략'을 진행 중입니다. 곧 더 많은 키워드를 통해 광고가 노출될 것 입니다.",
    CONVERSION_BUDGET_TOO_SMALL:
      '현재 입찰 경쟁이 심화되어 광고가 노출되지 않고 있습니다. \n\n입찰 경쟁력 개선을 위해 {campaign} 광고의 일 예산을 {min}으로 증액하는 것을 추천드립니다.',
    INCREASE_AUDIENCE_SIZE:
      '{campaign} 광고의 타겟 고객 수가 많지 않아 노출이 제한되고 있습니다. \n\n아드리엘 팀이 곧 타겟 고객 수 개선을 위해 조치를 취할 예정입니다 (예: 새로운 관심 그룹 설정 또는 더 넓은 범위의 나이대 설정 등). 문의사항은 온라인 채팅창에 남겨주세요.',
    LOW_RELEVANCY:
      '고객의 {campaign} 광고 피드백이 낮아 노출 페널티가 부가되었습니다. \n\n더 매력적인 소재로 변경해 주세요. 도움이 필요하시면 온라인 채팅창으로 부탁주세요.',
    INCREASE_CONVERSION_BID: '입찰가를 증액하여 {campaign} 광고가 더 노출이 될 수 있도록 조정하였습니다.',
    MORE_AGGRESSIVE_BID:
      '더 공격적인 입찰 전략을 택하여 {campaign} 광고가 더 높은 확률로 노출될 수 있도록 조정하였습니다.',
    TOO_MUCH_TEXT_IN_IMAGE:
      "{campaign} 광고 이미지 속 텍스트 비중이 높아 노출 페널티가 부가되었습니다. \n\n텍스트의 비중 (글자가 차지하는 면적)이 전체 이미지 면적의 20% 이하가 되도록 수정해 주세요. \n\n<a href='https://www.facebook.com/business/help/980593475366490'>페이스북 광고 정책 확인하기<a/> \n\n<a href='https://www.facebook.com/ads/tools/text_overlay'>노출 부가 여부 확인하기</a>",
    GO_TO_SETTINGS: '광고 설정 보기',
    google_search_campaign: '구글 검색',
    google_display_campaign: '구글 디스플레이',
    google_universal_appstore: '구글 앱 스토어 UAC',
    google_universal_playstore: '구글 플레이 스토어 UAC',
    google_campaign: '구글',
    facebook_instagram_campaign: '페이스북/인스타그램',
    instagram_campaign: '인스타그램',
    facebook_campaign: '페이스북',
    kakao_campaign: '카카오',
    apple_campaign: '애플',
  },
};
